module.exports = __webpack_public_path__ + "img/icons/new/rounded-corner-f7d04958d8c4a6a0f85fc0f243dc12c4.svg";